export default __webpack_public_path__ + "static/share-image-act-2-08fdfd9cb1798ef8b69e27bdd3c2ee82.png";